/* eslint-disable jsx-a11y/control-has-associated-label */
import PassivePagination from 'components/Pagination';
import SearchableHeader from 'components/SearchableHeader';
import SortableHeader from 'components/SortableHeader';
import useSortedSearch from 'hooks/useSortedSearch';
import AccessResource from 'models/access/resource';
import AccessSearcher from 'models/access/searcher';
import React, { useMemo, useState } from 'react';
import { Table } from 'react-bootstrap';
import * as Contexts from './Context';
import Create from './Create';
import Delete from './Delete';
import AccessRow from './Row';

type Props = {
  values: AccessResource[]
};

export const AccessTable = ({ values }: Props) => {
  const [selection, setSelection] = useState<Contexts.SelectionValue>({});
  const searcher = useMemo(() => new AccessSearcher(), []);
  const [sorted, sort, search, setSort, setSearch] = useSortedSearch(values, searcher, searcher, {
    type: 'company',
    asc: true,
  });

  const selectionValue: Contexts.SelectionContextValue = useMemo(() => ({
    selection,
    setSelection,
  }), [selection, setSelection]);

  return (
    <div className="uploads">
      <Contexts.SelectionContext.Provider value={selectionValue}>
        <Delete />
        <Table>
          <thead>
            <tr>
              <SearchableHeader value={search} types={['company']} onSearch={setSearch} />
              <th colSpan={3} />
            </tr>
            <tr>
              <SortableHeader value={sort} type="company" onChange={setSort}>
                Navn
              </SortableHeader>
              <SortableHeader className="upload-token" value={sort} type="token" onChange={setSort}>
                Upload kode
              </SortableHeader>
              <th>
                <Create />
              </th>
            </tr>
          </thead>
          <tbody>
            <PassivePagination
              items={sorted}
              renderItem={(item) => (
                // eslint-disable-next-line max-len
                <AccessRow key={item.token} value={item} />
              )}
            />
          </tbody>
        </Table>
      </Contexts.SelectionContext.Provider>
    </div>
  );
};

export default AccessTable;
